/**
 * Product View Tracker
 * Tracks when logged-in customers view products, stores in customer metafields via BE API
 */

(function() {
  'use strict';

  console.log('[ProductViewTracker] Script loaded');
  console.log('[ProductViewTracker] Current path:', window.location.pathname);

  // Only track on product pages
  if (!window.location.pathname.includes('/products/')) {
    console.log('[ProductViewTracker] Not a product page, skipping');
    return;
  }

  // Get product ID from meta tag (set in product template)
  const productIdMeta = document.querySelector('meta[name="product-id"]');
  if (!productIdMeta) {
    console.warn('[ProductViewTracker] No product-id meta tag found in <head>');
    return;
  }

  const productId = productIdMeta.content;
  console.log('[ProductViewTracker] Product ID:', productId);

  if (!productId) {
    console.warn('[ProductViewTracker] Product ID is empty');
    return;
  }

  // Check if customer is logged in via meta tag (set by Liquid)
  const customerLoggedInMeta = document.querySelector('meta[name="customer-logged-in"]');
  const customerIdMeta = document.querySelector('meta[name="customer-id"]');
  const isLoggedIn = customerLoggedInMeta && customerLoggedInMeta.content === 'true';
  const customerId = customerIdMeta ? customerIdMeta.content : null;

  console.log('[ProductViewTracker] Login check:', {
    isLoggedIn,
    customerId
  });

  if (isLoggedIn) {
    console.log('[ProductViewTracker] Customer logged in, tracking via API');
    trackProductView(productId, customerId);
  } else {
    console.log('[ProductViewTracker] Customer not logged in, tracking anonymously');
    trackAnonymously(productId);
  }

  function trackProductView(productId, customerId) {
    const apiUrl = window.EVERBEAN_API_URL || 'https://api.everbeankids.com';

    console.log('[ProductViewTracker] Sending POST to:', `${apiUrl}/api/v1/customer/track-view`);

    fetch(`${apiUrl}/api/v1/customer/track-view`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Send session cookies
      body: JSON.stringify({
        customer_id: customerId,
        product_id: productId,
        viewed_at: new Date().toISOString(),
        source: 'storefront'
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      console.log('[ProductViewTracker] View tracked:', data);
    })
    .catch(error => {
      console.error('[ProductViewTracker] Failed to track view:', error);
    });
  }

  function trackAnonymously(productId) {
    try {
      const storageKey = 'everbean_viewed_products';
      const existing = JSON.parse(localStorage.getItem(storageKey) || '[]');

      // Check if already tracked recently (within 24 hours)
      const recent = existing.find(v =>
        v.id === productId &&
        (Date.now() - new Date(v.at).getTime()) < 86400000
      );

      if (!recent) {
        existing.push({
          id: productId,
          at: new Date().toISOString()
        });

        // Keep only last 50 views
        if (existing.length > 50) {
          existing.shift();
        }

        localStorage.setItem(storageKey, JSON.stringify(existing));
      }
    } catch (e) {
      // localStorage might be disabled
      console.warn('[ProductViewTracker] localStorage unavailable:', e);
    }
  }
})();
